import * as z from "zod";

const assignmentStatusSchema = z.enum(["focus", "queue", "done", "blocked", "on-hold", "waiting"]);

export const assignmentRowSchema = z.object({
    userPid: z.string(),
    status: assignmentStatusSchema,
    icTask: z
        .string()
        .trim()
        .max(2000, "IC Task must be at most 2000 characters"),
    isDri: z.boolean().default(false),
    blockerUserPid: z.string().optional(),
    blockedReason: z.string().max(4000, "Blocked reason must be at most 4000 characters").optional(),
})
    .refine((data) => {
        if (data.status === "blocked" && !data.blockerUserPid) return false;
        return true;
    }, {
        message: "Blocker is required when status is Block Int",
        path: ["blockerUserPid"],
    })
    .refine((data) => {
        if (data.status === "blocked" && !(data.blockedReason?.trim())) return false;
        return true;
    }, {
        message: "Blocked reason is required when status is Block Int",
        path: ["blockedReason"],
    });

export const prioritySchema = z.object({
    name: z.string().min(3, "Name must be at least 3 characters"),
    type: z.enum(["SHP", "WKR", "DAS"]),
    description: z.string().optional(),
    weekNumber: z.number().min(1).max(53).optional().or(z.literal(0).transform(() => undefined)),
    weekYear: z.number().min(2000).max(2100).optional().or(z.literal(0).transform(() => undefined)),
    assignments: z.array(assignmentRowSchema).default([]),
    status: assignmentStatusSchema.optional(),
    isConfidential: z.boolean().default(false),
    /** PPP links. The BE requires at least one on create and refuses unlinking to zero
     * (`PRIORITY_PPP_REQUIRED`); only the DRI is optional, and its absence is what makes a candidate. */
    pppPids: z.array(z.string()).min(1, "Pick at least one PPP"),
}).refine((data) => data.assignments.filter((a) => a.isDri).length <= 1, {
    message: "Only one DRI per deliverable",
    path: ["assignments"],
});

export type PriorityFormValues = z.infer<typeof prioritySchema>;
